import { makePost, makePut } from './ServiceManager';
import domains from '../containers/Domains';

const host = (window.location.hostname !== 'localhost') ? domains[window.location.hostname] : domains['lambda-users'];

export const getUsers = async (user) => {
  const result = await makePost('user/users', user, host);
  return result;
};

export const addUser = async (user) => {
  const result = await makePost('user/adduser', user, host);
  return result;
};

export const updateUser = async (user) => {
  const result = await makePut('user/user', user, host);
  return result;
};

export const changeUserStatus = async (user) => {
  const result = await makePost('user/changestatus', user, host);
  return result;
};

export const getGroups = async (user) => {
  const result = await makePost('user/groups', user, host);
  return result;
};

export const getGroupsForUser = async (user) => {
  const result = await makePost('user/usergroup', user, host);
  return result;
};



// WEBPACK FOOTER //
// ./src/services/UserManagementService.js